export default function isDateInCurrentMonth(date) {
	const currentDate = new Date();
	const dateToCheck = new Date(date);

	return dateToCheck.getMonth() === currentDate.getMonth() &&
           dateToCheck.getFullYear() === currentDate.getFullYear();
}